import { InspectionSummaryCardLoading } from './inspection-summary-card'

type InspectionListCardLoadingType =
	| 'seeAndAct'
	| 'yellowCard'
	| 'interaction'
	| 'directed'
	| 'dds'

interface InspectionListCardLoadingProps {
	type: InspectionListCardLoadingType
	className?: string
}

const ACCENT_CLASS_BY_TYPE: Record<InspectionListCardLoadingType, string> = {
	seeAndAct: 'border-l-kaefer-grass-green',
	yellowCard: 'border-l-kaefer-sunny-yellow',
	interaction: 'border-l-kaefer-violet',
	directed: 'border-l-kaefer-ocean-blue',
	dds: 'border-l-kaefer-honey-yellow',
}

export const InspectionListCardLoading = ({
	type,
	className,
}: InspectionListCardLoadingProps) => {
	return (
		<InspectionSummaryCardLoading
			accentClassName={ACCENT_CLASS_BY_TYPE[type]}
			className={className}
		/>
	)
}
